import classes from 'classnames';
import React, { memo, ReactNode } from 'react';
import Ripples from 'react-ripples';
import styles from './Touchable.module.scss';

export type Props = {
  children: ReactNode;
  disabled?: boolean;
  className?: string;
  dataTest?: string;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onMouseEnter?: (event?: React.MouseEvent<HTMLButtonElement>) => void;
  buttonClassName?: string;
  rippleColor?: string;
  rounded?: boolean;
};

const TouchableMemo = memo(function Touchable({
  children,
  disabled = false,
  className,
  dataTest,
  onClick,
  onMouseEnter,
  buttonClassName,
  rippleColor = 'rgba(25, 175, 214, 0.3)',
  rounded = false,
}: Props) {
  return (
    <Ripples
      className={classes(
        className,
        styles.ripples,
        rounded && styles.rounded,
        disabled && styles.disabled,
      )}
      color={disabled ? '' : rippleColor}
      placeholder={undefined}
      onPointerEnterCapture={undefined}
      onPointerLeaveCapture={undefined}
    >
      <button
        className={classes(buttonClassName, styles.button)}
        data-test={dataTest}
        type="button"
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        disabled={disabled}
      >
        {children}
      </button>
    </Ripples>
  );
});

export default TouchableMemo;
